import { createStore } from "vuex";

import results from './modules/results';
import chartsParams from './modules/chartsParams';
import profilingParams from './modules/profilingParams';
import report from './modules/report';
import lidars from './modules/lidars';
import createPersistedState from "vuex-persistedstate";

// In local mode the users module (login/register/profile API) is excluded
// from the bundle. The router still references store.getters.isAuthenticated,
// so we provide a stub module that always reports the user as authenticated.
const isLocalMode = process.env.VUE_APP_MODE === 'local';

let usersModule;
if (isLocalMode) {
  usersModule = {
    state: { user: { id: 0, email: 'local@local', username: 'local', role: 'admin' } },
    getters: {
      isAuthenticated: () => true,
      stateUser: state => state.user,
      // Local backend answers as admin (see jwthandler._LOCAL_USER).
      isAdmin: () => true,
      currentUserUid: () => null,
    },
    actions: {
      // no-op so dispatch('logOut') from NavBar doesn't fail in local builds.
      async logOut() {},
    },
    mutations: {},
  };
} else {
  // eslint-disable-next-line global-require
  usersModule = require('./modules/users').default;
}

export default createStore({
  modules: {
    users: usersModule,
    results,
    chartsParams,
    profilingParams,
    report,
    lidars,
  },
  plugins: [
    createPersistedState({
      reducer: (state) => {
        // eslint-disable-next-line no-unused-vars
        const { trackPoints, ...resultsRest } = state.results || {};
        const {
          // eslint-disable-next-line no-unused-vars
          points,
          // eslint-disable-next-line no-unused-vars
          selectedPoint,
          ...profilingRest
        } = state.profilingParams || {};
        const charts = state.chartsParams || {};
        const slimParameters = (charts.parameters || []).map(
          // eslint-disable-next-line no-unused-vars
          ({ data, labels, ...rest }) => ({ ...rest, data: [], labels: [] })
        );
        return {
          ...state,
          results: resultsRest,
          profilingParams: profilingRest,
          chartsParams: { ...charts, parameters: slimParameters },
        };
      },
    }),
  ],
});
